/**
 * Shared SQL predicates for durable photo upload failures. Each expects the
 * attachments table aliased as `a`.
 */

/**
 * A durable failure whose bytes are still on this device. Doesn't require the
 * photos row, so counts taken while synced tables are empty (reset) still see
 * every retained failure.
 */
export const RETAINED_FAILURE_CONDITION = `
  EXISTS (SELECT 1 FROM attachment_failures f WHERE f.id = a.id)
  AND a.has_synced = 0
  AND a.local_uri IS NOT NULL AND a.local_uri != ''
`

/**
 * A durable failure the user can see and retry: also requires the photo row.
 * Used by photo badges, failure lists and #282's upload monitor.
 */
export const FAILED_PHOTO_CONDITION = `
  ${RETAINED_FAILURE_CONDITION}
  AND EXISTS (SELECT 1 FROM photos p WHERE p.id = a.id)
`

/**
 * `attachment_queue_meta` key prefix marking a photo whose upload is the daily
 * automatic retry. Persisted, so the mark survives transient errors and
 * restarts between that attempt and its next permanent rejection.
 */
export const AUTOMATIC_RETRY_MARKER_PREFIX = "automatic-retry:"

/** A server configuration fix can recover without an app update or user action. */
export const FAILED_PHOTO_RETRY_DELAY_MS = 24 * 60 * 60 * 1000
